import Vue from "vue";
import Vuex from "vuex";
import globalService from "../services/global.service";
// import app from "@/main";
import administratorAPI from "@/views/modules/administrator/administrator.api";
import userService from "@/services/auth/user.service";

import requestData from "@/store/modules/RequestData.store";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		initialized: false,
		refCount: 0,
		loading: false,
		loadingMessage: "",
		config: {
			apiUrl: "",
		},
		// accessToken: "",
		// refreshToken: "",
		// ssoData: null,
		breadcrumbs: null,
		listStatus: [],
		currentUserInfo: null,
		customColors: {
			"mbf-color-1": "#F0F0F0",
			"mbf-color-2": "#F6A148",
			"mbf-color-3": "#0061AF",
			"mbf-color-4": "#002060",
			"mbf-color-5": "#A5AAB6",
			"mbf-color-6": "#F7F9FE",
			"mbf-color-7": "#1FA1DB",
			"mbf-color-8": "#010B3A",
			"mbf-color-9": "#007AFF",
		},
	},
	getters: {},
	mutations: {
		loading(state, loading) {
			if (loading) {
				state.refCount++;
				state.loading = true;
			} else if (state.refCount > 0) {
				state.refCount--;
				state.loading = state.refCount > 0;
				if (!state.loading) {
					state.loadingMessage = "";
				}
			}
		},
		setLoadingMessage(state, payload) {
			state.loadingMessage = payload;
		},
		SET_BREADCRUMBS(state, payload) {
			state.breadcrumbs = payload;
		},
		SET_CURRENT_USER_INFO(state, payload) {
			state.currentUserInfo = payload;
		},
	},
	config: {
		apiUrl: "",
	},
	actions: {
		initialize() {
			this.state.initialized = true;
			this.state.config = {
				apiUrl:
					window.__APP_CONFIG__?.API_URL || process.env.VUE_APP_API_URL,
			};
		},

		async getListStatus() {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetAllStatus(),
				);
				if (!response?.data || !response?.data?.length) {
					return;
				}
				if (response?.data?.length > 0) {
					this.state.listStatus = response.data.filter(
						(entry) => !entry.isDelete && entry.isActive,
					);
				}
			} catch (e) {
				console.error("getListStatus", e);
			}
		},
		async getCurrentUserInfo() {
			const localData = userService.getUserInfo();
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetCurrentUserInfo(),
				);
				if (!response?.data?.id) {
					return;
				}
				if (response.data.id && localData?.id) {
					const updatedData = Object.assign(localData, response.data);
					this.state.currentUserInfo = updatedData;
					userService.setUserInfo(updatedData);
				} else if (response.data.id && !localData?.id) {
					this.state.currentUserInfo = response.data;
					userService.setUserInfo(response.data);
				}
			} catch (e) {
				console.error("getCurrentUserInfo", e);
			}
		},
	},
	modules: {
		requestData,
	},
});
export default store;
